const META_PIXEL_ID = '947071294649317'

let initialized = false

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return

  try {
    // Meta Pixel base code
    const f = window
    const b = document
    const n = (f.fbq = function (...args: any[]) {
      if (n.callMethod) {
        n.callMethod.apply(n, args)
      } else {
        n.queue.push(args)
      }
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = [] as any[]

    // Load the Facebook pixel script
    const t = b.createElement('script') as HTMLScriptElement
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const s = b.getElementsByTagName('script')[0]
    s?.parentNode?.insertBefore(t, s)

    // Initialize and track page view
    window.fbq('init', META_PIXEL_ID)
    window.fbq('track', 'PageView')

    // Add noscript fallback
    const noscript = b.createElement('noscript')
    const img = b.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    b.body.appendChild(noscript)

    initialized = true
    console.log('✅ Meta Pixel initialized:', META_PIXEL_ID)
  } catch (e) {
    console.error('❌ Meta Pixel init error:', e)
  }
}

export function trackPageView() {
  try {
    if (initialized && window.fbq) {
      window.fbq('track', 'PageView')
    }
  } catch {
    // Silently fail
  }
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  try {
    if (initialized && window.fbq) {
      window.fbq('track', eventName, params)
    }
  } catch {
    // Silently fail
  }
}

export function trackCustomEvent(
  eventName: string,
  params?: Record<string, any>,
) {
  try {
    if (initialized && window.fbq) {
      window.fbq('trackCustom', eventName, params)
    }
  } catch {
    // Silently fail
  }
}

// Common event helpers
export const metaEvents = {
  completeRegistration: (params?: { value?: number; currency?: string }) => {
    trackEvent('CompleteRegistration', params)
  },

  startTrial: () => {
    trackEvent('StartTrial')
  },

  subscribe: (value: number, currency: string) => {
    trackEvent('Subscribe', { value, currency })
  },

  initiateCheckout: (value?: number, currency?: string) => {
    trackEvent('InitiateCheckout', { value, currency })
  },

  viewContent: (contentName?: string) => {
    trackEvent('ViewContent', { content_name: contentName })
  },

  contact: () => {
    trackEvent('Contact')
  },

  lead: () => {
    trackEvent('Lead')
  },
}
